import React from 'react'
import { PriceString } from '../../../../functional/PriceString'
import * as S from './styled'
import type { Props } from './types'

export const CostItem = ({ name, bold, value, negative }: Props) => {
  return (
    <S.Container $bold={bold}>
      <S.Text>{name}</S.Text>
      <S.Cost>
        <PriceString value={value} negative={negative} />
      </S.Cost>
    </S.Container>
  )
}
